import { Action, ThunkAction, ThunkDispatch } from '@reduxjs/toolkit';
import { UiState } from './ui/types';
import { UsersState } from './users/types';
import { ClientsState } from './clients/types';
import { UserState } from './user/types';
import { DataState } from './data/types';
import { SettingsState } from './settings/types';
import { FilesState } from './files/types';
import { PaymentsState } from './payments/types';
import { MessagesState } from './messages/types';
import { LandingState } from './landing/types';
import { NotificationsState } from './notifications/types';
import { TasksState } from './tasks/types';
import { DomainsState } from './domains/types';
import { IntakeFormsState } from './intake_forms/types';
import { SignaturePageState } from './signaturePage/types';
import { DashboardState } from './dashboard/types';
import { KnowledgeBaseState } from './knowledgeBase/types';
import { TagsState } from './tags/types';
import { TablePropertiesState } from './tableProperties/types';

export interface RootState {
  user: UserState;
  users: UsersState;
  clients: ClientsState;
  ui: UiState;
  data: DataState;
  settings: SettingsState;
  files: FilesState;
  payments: PaymentsState;
  messages: MessagesState;
  landings: LandingState;
  notifications: NotificationsState;
  tasks: TasksState;
  domains: DomainsState;
  intakeForms: IntakeFormsState;
  // runtime,
  signaturePage: SignaturePageState;
  tags: TagsState;
  knowledgeBase: KnowledgeBaseState;
  dashboard: DashboardState;
  tableProperties: TablePropertiesState;
}

export type AppThunkAction<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action
>;

export type AppThunkDispatch = ThunkDispatch<RootState, unknown, Action>;

export interface BaseItemsState<T> {
  items: T[];
  itemsLoading: boolean;
  itemsLoaded: boolean;
  selectedItemId: string;
  selectedItemType?: string;
  loadingError: string;
  creatingItem: boolean;
  createError: string;
}

export enum BaseItemsActionTypes {
  GET_ITEMS = 'GET_ITEMS',
  GET_ITEMS_SUCCESS = 'GET_FILES_SUCCESS',
  GET_ITEMS_ERROR = 'GET_ITEMS_ERROR',
  CREATE_ITEMS_ERROR = 'CREATE_ITEMS_ERROR',
  SET_SELECTED_ITEM = 'SET_SELECTED_ITEM',
  CREATING_ITEM = 'CREATING_ITEM',
}

export const startGetItemsAction = () => ({
  type: BaseItemsActionTypes.GET_ITEMS,
});

export const getItemsErrorAction = (error: string) => ({
  type: BaseItemsActionTypes.GET_ITEMS_ERROR,
  error,
});

export const creatingItemAction = () => ({
  type: BaseItemsActionTypes.CREATING_ITEM,
});

export const createItemErrorAction = (error: string) => ({
  type: BaseItemsActionTypes.CREATE_ITEMS_ERROR,
  error,
});

export interface SetSelectedItemActionOptions {
  itemType?: string;
}
export const setSelectedItemAction = (
  itemId: string,
  options?: SetSelectedItemActionOptions,
) => ({
  type: BaseItemsActionTypes.SET_SELECTED_ITEM,
  itemId,
  options,
});

export interface StartGetItemsActionType {
  type: typeof BaseItemsActionTypes.GET_ITEMS;
}

export interface GetItemsErrorActionType {
  type: typeof BaseItemsActionTypes.GET_ITEMS_ERROR;
  error: string;
}

export interface CreateItemActionType {
  type: typeof BaseItemsActionTypes.CREATING_ITEM;
}

export interface CreateItemErrorActionType {
  type: typeof BaseItemsActionTypes.CREATE_ITEMS_ERROR;
  error: string;
}

export interface SetSelectedItemActionType {
  type: typeof BaseItemsActionTypes.SET_SELECTED_ITEM;
  itemId: string;
  options?: SetSelectedItemActionOptions;
}

export type BaseItemActions =
  | StartGetItemsActionType
  | GetItemsErrorActionType
  | SetSelectedItemActionType
  | CreateItemActionType
  | CreateItemErrorActionType;

export const BaseItemsInitialState = {
  items: [],
  itemsLoading: false,
  itemsLoaded: false,
  selectedItemId: '',
  selectedItemType: '',
  loadingError: '',
  creatingItem: false,
  createError: '',
};
